import React from 'react';
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  Button,
  ButtonGroup,
} from '@stockx/ui';
import { useConfirmModal } from '@stockx/ui-modals';

const ConfirmModal = () => {
  const [
    ,
    {
      isModalOpen,
      modalHeader,
      modalBody,
      modalSize,
      confirmText,
      cancelText,
      onConfirm,
      onCancel,
    },
  ] = useConfirmModal();

  return (
    <Modal
      isOpen={isModalOpen}
      closeOnOverlayClick={false}
      onClose={onCancel}
      isCentered
      size={modalSize}
      // fresh DOM entry to even appear on top of other modals
      portalProps={{
        appendToParentPortal: false,
      }}
    >
      <ModalOverlay />
      <ModalContent bg="neutral.white">
        <ModalHeader textAlign="center">{modalHeader}</ModalHeader>
        <ModalBody>{modalBody}</ModalBody>
        <ModalFooter justifyContent="center">
          <ButtonGroup>
            <Button variant="primary" size="md" onClick={onConfirm}>
              {confirmText}
            </Button>
            <Button variant="secondary" size="md" onClick={onCancel}>
              {cancelText}
            </Button>
          </ButtonGroup>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default ConfirmModal;
